// Amounts: Indian grouping (1,23,456.50), always paise; Dr / Cr sides.
export type Side = "Dr" | "Cr";

const FMT = new Intl.NumberFormat("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const fmtAmount = (n: number | null | undefined) => (n == null ? "" : FMT.format(n));

// "1,500.5" → 1500.5; "" → null; anything else (letters, three decimals) → NaN
export function parseAmount(s: string): number | null {
  const t = s.replace(/[,\s₹]/g, "");
  if (t === "") return null;
  if (!/^\d+(\.\d{1,2})?$/.test(t)) return NaN;
  return Number(t);
}

// signed: Dr positive, Cr negative
export const signed = (side: Side | null | undefined, amount: number | null | undefined) =>
  amount == null ? 0 : side === "Cr" ? -amount : amount;

export function fmtSigned(n: number): string {
  if (Math.abs(n) < 0.005) return "0.00";
  return `${fmtAmount(Math.abs(n))} ${n > 0 ? "Dr" : "Cr"}`;
}

// a ledger's usual side: assets and expenses Dr, liabilities and incomes Cr
export const usualSide = (nature: string | undefined): Side => (nature === "L" || nature === "I" ? "Cr" : "Dr");
